import React from 'react';
export function Footer() {
  return <footer className="py-12 bg-surfaceLight border-t border-slate-200 text-center" role="contentinfo" data-id="element-154">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-155">
        <div className="mb-8" data-id="element-156">
          <h2 className="font-heading text-xl font-extrabold text-slate-900 mb-2" data-id="element-157">
            🎓 MATEMÁTICAS SIN LÁGRIMAS
          </h2>
          <p className="text-primary-dark font-bold text-sm mb-3" data-id="element-158">
            El sistema N°1 para padres que quieren acompañar el aprendizaje
            matemático de sus hijos en Argentina.
          </p>
          <p className="text-slate-600 max-w-md mx-auto font-medium text-sm" data-id="element-159">
            Sin bloqueos, sin peleas, con confianza real.
          </p>
        </div>

        <nav aria-label="Contacto y redes sociales" className="flex flex-wrap justify-center items-center gap-5 md:gap-6 text-slate-500 text-xs mb-8 font-bold" data-id="element-160">
          <a href="mailto:soporteoficialfegion@gmail.com" className="hover:text-primary transition-colors flex items-center gap-1.5" data-id="element-161">
            📧 soportetupuntodigital@gmail.com
          </a>
          <span className="hidden md:inline text-slate-300" aria-hidden="true" data-id="element-162">
            |
          </span>
          <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors flex items-center gap-1.5" data-id="element-163">
            📲 @tu_punto_digitall
          </a>
          <span className="hidden md:inline text-slate-300" aria-hidden="true" data-id="element-164">
            |
          </span>
          <a href="https://www.fegion.shop" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors flex items-center gap-1.5" data-id="element-165">
            🌐 www.tupuntodigital.shop
          </a>
        </nav>

        <div className="border-t border-slate-200 pt-6" data-id="element-166">
          <p className="text-slate-500 text-[10px] md:text-xs mb-3 font-bold" data-id="element-167">
            © Matemáticas Sin Lágrimas · Fegion 2026 — Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p className="text-slate-500 text-xs italic font-bold" data-id="element-168">
            🎓 "Desde hoy, la hora de la tarea de matemáticas tiene sistema."
          </p>
        </div>
      </div>
    </footer>;
}